var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m71.722 25.914-21.75 2-21.75 2-13 20.5 39 29.5 34.605-36.87-17.105-17.13Z",
    fill: "#FFC239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m71.722 25.914 17.106 17.13m-17.106-17.13L65.63 45.366m6.092-19.452-21.75 2m38.855 15.13-34.605 36.87m34.605-36.87L65.63 45.365m-50.408 5.048 13-20.5m-13 20.5 39 29.5m-39-29.5 22.169-2.22m-9.17-18.28 9.17 18.28m-9.17-18.28 21.751-2m4.25 52-16.831-31.72m16.831 31.72L65.63 45.366m-28.24 2.828 28.24-2.828m-28.24 2.828 12.582-20.28M65.63 45.366 49.972 27.914",
    stroke: "#0D0D0D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.63e986e38c2fb9709adf7f25aeb540c1.svg";
export { ForwardRef as ReactComponent };